import ContentRoutes from 'ContentUtils/Routes';
import { ListItem } from 'foundations-components/transitional/components/List';
import Raven from 'raven-js';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getContentModelId } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getHasUnsavedChanges } from 'ContentEditorUI/redux/selectors/saveDataSelectors';
import { getCategoryId } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';

// @ts-ignore actions not typed yet
import { autoSave as autoSaveAction } from '../redux/actions/pageSaveActions';
import ContentEditorVariantSelect from 'personalization-lib/components/variantSelect/ContentEditorVariantSelect';
import { VARIANT_SELECT_MODES } from 'personalization-lib/constants/variantSelect';
import { STRATEGY_TYPES } from 'personalization-lib/constants/strategyType';
import useVariants from 'personalization-lib/hooks/variants/useVariants';
import { getContentModelPersonalizationStrategyId } from 'page-editor-ui/redux/selectors/pageContentModelSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
export const PersonalizationVariantControls = () => {
  const currentId = useSelector(getContentModelId);
  const categoryId = useSelector(getCategoryId);
  const strategyId = useSelector(getContentModelPersonalizationStrategyId);
  const {
    strategyType
  } = useVariants(strategyId ? Number(strategyId) : undefined);
  const hasUnsavedChanges = useSelector(getHasUnsavedChanges);
  const dispatch = useDispatch();
  const onSelectVariant = useCallback(variantId => {
    const variantRoute = ContentRoutes.edit(variantId, categoryId);
    if (hasUnsavedChanges) {
      dispatch(autoSaveAction()).then(() => {
        window.location = variantRoute;
      }).catch(e => {
        console.error(e);
      });
    } else {
      window.location = variantRoute;
    }
  }, [dispatch, hasUnsavedChanges, categoryId]);
  return /*#__PURE__*/_jsx(ListItem, {
    "data-test-id": "personalization-variant-controls",
    children: /*#__PURE__*/_jsx(ContentEditorVariantSelect, {
      value: currentId,
      mode: strategyType === STRATEGY_TYPES.ABM ? VARIANT_SELECT_MODES.ABM : VARIANT_SELECT_MODES.DEFAULT,
      onChange: onSelectVariant,
      onError: error => {
        Raven.captureMessage('[P13n] - Error fetching personalization variants', {
          extra: {
            error
          }
        });
      }
    })
  });
};